/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CursorsVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class CursorsVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.CursorsVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.CursorsVMBehavior.prototype */ {
      __name: "CursorsVMBehavior",

      watchedAttributes: {
        container: ["cursor", "cursor2", "currentRow", "offset", "currentColumn", "dialogType"],
        table: ["currentRow", "currentColumn", "offset", "dialogType"]
      },

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();

        if (!widget.hasCursors()) {
          return;
        }

        const anchorNode = controller.getAnchorNode();
        let cursorNode = anchorNode;
        if (!cursorNode.isAttributePresent("cursor")) {
          cursorNode = anchorNode.getAncestorWithAttribute("cursor");
        }

        const cursor = cursorNode.attribute("cursor");
        const cursor2 = cursorNode.attribute("cursor2");

        widget.setCursors(cursor, cursor2);
      }
    };
  });
});
